<template>
    <div class="x-table-server" v-loading="loading">
        <div class="x-table-server-section-title" v-if="showSectionTitle">
            <div class="d-flex align-items-center justify-content-between w-100">
                <div class="title">{{ title }}</div>
                <div class="d-flex align-items-center">
                    <slot name="button-actions"></slot>
                    <x-button-primary text="Nuevo"
                                      @click="clickCreate()"
                                      v-if="showButtonNew"></x-button-primary>
                    <x-button-icon icon="fa-light fa-file-export"
                                   @click="clickExport"
                                   v-if="showButtonExport"></x-button-icon>
                    <x-button-icon icon="fa-light fa-filter"
                                   v-if="showFilter"
                                   @click="showDialogFilter = true"></x-button-icon>
                    <el-dropdown v-if="showButtonColumns" class="ml-2">
                        <x-button-icon icon="fa-light fa-table-columns"></x-button-icon>
                        <el-dropdown-menu class="x-table-server-dropdown-menu" slot="dropdown">
                            <el-checkbox-group v-model="selectVisibleColumns">
                                <el-checkbox v-for="col in selectColumns" :label="col.value" :key="col.value">
                                    {{ col.label }}
                                </el-checkbox>
                            </el-checkbox-group>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>
        <!--        <div class="x-table-server-section-filters">-->
        <!--            <div class="row q-col-gutter-x-sm q-col-gutter-y-sm">-->
        <!--                <template v-for="f in filters">-->
        <!--                    <div :class="f.class" v-if="f.type === 'select'">-->
        <!--                        <x-select v-model="f.value"-->
        <!--                                  :label="f.label"-->
        <!--                                  :options="f.options"-->
        <!--                                  @input="changeFilter"></x-select>-->
        <!--                    </div>-->
        <!--                    <div :class="f.class" v-if="f.field === 'period'">-->
        <!--                        <div class="row">-->
        <!--                            <div class="col-12 col-sm-4">-->
        <!--                                <x-select v-model="f.value"-->
        <!--                                          :label="f.label"-->
        <!--                                          :options="f.options"-->
        <!--                                          @input="changeFilter"></x-select>-->
        <!--                            </div>-->
        <!--                            <template v-if="f.value === 'date' || f.value === 'between_dates'">-->
        <!--                                <div class="col-12 col-sm-4">-->
        <!--                                    <x-date-picker v-model="f.date_start"-->
        <!--                                                   label="Fecha del"-->
        <!--                                                   @input="changeFilter"></x-date-picker>-->
        <!--                                </div>-->
        <!--                            </template>-->
        <!--                            <template v-if="f.value === 'between_dates'">-->
        <!--                                <div class="col-12 col-sm-4">-->
        <!--                                    <x-date-picker v-model="f.date_start"-->
        <!--                                                   label="Fecha al"-->
        <!--                                                   @input="changeDateEnd"></x-date-picker>-->
        <!--                                </div>-->
        <!--                            </template>-->
        <!--                            <template v-if="f.value === 'month' || f.value === 'between_months'">-->
        <!--                                <div class="col-12 col-sm-4">-->
        <!--                                    <x-date-picker v-model="f.month_start"-->
        <!--                                                   label="Mes del"-->
        <!--                                                   type="month"-->
        <!--                                                   @input="changeFilter"></x-date-picker>-->
        <!--                                </div>-->
        <!--                            </template>-->
        <!--                            <template v-if="f.value === 'between_months'">-->
        <!--                                <div class="col-12 col-sm-4">-->
        <!--                                    <x-date-picker v-model="f.month_end"-->
        <!--                                                   label="Mes al"-->
        <!--                                                   type="month"-->
        <!--                                                   @input="changeMonthEnd"></x-date-picker>-->
        <!--                                </div>-->
        <!--                            </template>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                    <div :class="f.class" v-if="f.type === 'input'">-->
        <!--                        <x-input :label="f.label"-->
        <!--                                 v-model="f.value"-->
        <!--                                 @input="changeFilter"></x-input>-->
        <!--                    </div>-->
        <!--                </template>-->
        <!--            </div>-->
        <!--        </div>-->
        <div class="x-table-server-section-content">
            <div>
                <table class="table table-hover">
                    <thead>
                    <tr>
                        <th v-for="col in visibleColumns" :key="col.name" :class="col.class_col_head"
                            :style="col.style">{{ col.label }}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <slot name="table-rows" :records="records" :columns="visibleColumns"></slot>
                    </tbody>
                </table>
            </div>
            <div class="row justify-content-end">
                <div class="col-12 text-right">
                    <el-pagination
                        @size-change="changePageSize"
                        @current-change="changeFilter"
                        layout="total, sizes, prev, pager, next"
                        :total="pagination.rowsNumber"
                        :current-page.sync="pagination.page"
                        :page-sizes="pagination.pageSizes"
                        :page-size.sync="pagination.rowsPerPage">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog :visible="showDialogFilter"
                   :show-close="false"
                   :close-on-click-modal="false"
                   append-to-body
                   custom-class="x-modal-filter-container">
            <div class="x-modal-filter" v-loading="loading">
                <div class="x-modal-filter-header">
                    <div class="title">Filtro</div>
                    <div class="button-close">
                        <i class="fa-light fa-xmark" @click="showDialogFilter = false"></i>
                    </div>
                </div>
                <div class="x-modal-filter-body">
                    <div class="row q-col-gutter-x-sm q-col-gutter-y-sm">
                        <template v-for="f in filters">
                            <div :class="f.class" v-if="f.type === 'select'">
                                <x-select v-model="f.value"
                                          :label="f.label"
                                          :options="f.options"
                                          @input="changeFilter"></x-select>
                            </div>
                            <div :class="f.class" v-if="f.field === 'period'">
                                <div class="row">
                                    <div class="col-6">
                                        <x-select v-model="f.value"
                                                  :label="f.label"
                                                  :options="f.options"
                                                  @input="changeFilter"></x-select>
                                    </div>
                                    <template v-if="f.value === 'date' || f.value === 'between_dates'">
                                        <div class="col-6">
                                            <x-date-picker v-model="f.date_start"
                                                           label="Fecha del"
                                                           @input="changeDateStart"></x-date-picker>
                                        </div>
                                    </template>
                                    <template v-if="f.value === 'between_dates'">
                                        <div class="col-6">
                                            <x-date-picker v-model="f.date_end"
                                                           label="Fecha al"
                                                           @input="changeDateEnd"></x-date-picker>
                                        </div>
                                    </template>
                                    <template v-if="f.value === 'month' || f.value === 'between_months'">
                                        <div class="col-6">
                                            <x-date-picker v-model="f.month_start"
                                                           label="Mes del"
                                                           type="month"
                                                           @input="changeFilter"></x-date-picker>
                                        </div>
                                    </template>
                                    <template v-if="f.value === 'between_months'">
                                        <div class="col-6">
                                            <x-date-picker v-model="f.month_end"
                                                           label="Mes al"
                                                           type="month"
                                                           @input="changeMonthEnd"></x-date-picker>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div :class="f.class" v-if="f.type === 'input'">
                                <x-input :label="f.label"
                                         v-model="f.value"
                                         @input="changeFilter"></x-input>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>

import XButtonPrimary from "./XButtonPrimary";
import XInput from "./XInput";
import XSelect from "./XSelect.vue";
import XDatePicker from "./XDatePicker.vue";
import XButtonIcon from "./XButtonIcon.vue";

export default {
    name: 'XTableServer',
    components: {XButtonIcon, XDatePicker, XSelect, XInput, XButtonPrimary},
    props: {
        title: {
            type: String,
            required: true,
        },
        resourceInit: {
            default: null,
        },
        resource: {
            type: String,
            required: true,
        },
        showSectionTitle: {
            type: Boolean,
            default: true
        },
        showFilter: {
            type: Boolean,
            default: false
        },
        showButtonNew: {
            type: Boolean,
            default: true
        },
        showButtonExport: {
            type: Boolean,
            default: false
        },
        showButtonColumns: {
            type: Boolean,
            default: true
        },
        additionalFilters: {
            type: Array,
            default() {
                return []
            }
        },
        reloadTableServer: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            loading: false,
            showDialogFilter: false,
            columns: [],
            filters: [],
            lockedColumns: [],
            records: [],
            pagination: {},
            selectVisibleColumns: [],
            selectColumns: [],
            items: [],
        }
    },
    async mounted() {
        this.initForm()
        this.initTableServer();
        await this.getInitTable();
        await this.changeFilter();
    },
    watch: {
        reloadTableServer(val) {
            if (val) {
                this.onRequest({pagination: this.pagination});
                this.$emit('update:reloadTableServer', false)
            }
        }
    },
    computed: {
        visibleColumns: {
            get: function () {
                let vc = this.lockedColumns.concat(this.selectVisibleColumns)
                let h = [];
                this.columns.forEach(hc => {
                    if (vc.indexOf(hc.name) > -1) {
                        h.push(hc)
                    }
                });
                return h;
            },
        }
    },
    methods: {
        initForm() {
            this.loading = false
            this.columns = []
            this.filters = []
            this.lockedColumns = []
            this.records = []
            this.pagination = {
                sortBy: null,
                descending: null,
                page: 1,
                rowsPerPage: 1,
                rowsNumber: 1,
                pageSizes: []
            }
            this.selectVisibleColumns = []
            this.selectColumns = []
            this.items = []
        },
        initTableServer() {
            this.pagination = {
                sortBy: null,
                descending: null,
                page: 1,
                rowsPerPage: 1,
                rowsNumber: 1,
                pageSizes: []
            };
        },
        getVisibleColumns() {
            this.columns.forEach(col => {
                if (!this.lockedColumns.includes(col.name)) {
                    this.selectColumns.push({
                        'label': col.label,
                        'value': col.name,
                    });
                    this.selectVisibleColumns.push(col.name);
                }
            })
        },
        async getInitTable() {
            this.loading = true;
            let resourceInit = (!this.resourceInit) ? this.resource : this.resourceInit;
            await this.$http.get(`/${resourceInit}/init_data_table`)
                .then(response => {
                    this.columns = response.data.columns;
                    this.filters = response.data.filters;
                    this.lockedColumns = response.data.locked_columns;
                    this.pagination.sortBy = response.data.pagination.sort_by;
                    this.pagination.descending = response.data.pagination.descending;
                    this.pagination.rowsPerPage = response.data.pagination.limit;
                    this.pagination.pageSizes = _.orderBy(response.data.pagination.page_sizes);
                });
            this.getVisibleColumns();
            this.loading = false;
        },
        async onRequest(data) {
            const {page, rowsPerPage, sortBy, descending} = data.pagination
            const fetchCount = rowsPerPage === 0 ? this.pagination.rowsNumber : rowsPerPage;
            this.loading = true;
            this.records = [];

            await this.$http.post(`/${this.resource}/records`, {
                'page': page,
                'limit': fetchCount,
                'sortBy': sortBy,
                'descending': descending,
                'filters': this.filters.concat(this.additionalFilters),
            })
                .then(response => {
                    let data = response.data;
                    this.records = data.data;
                    this.pagination.page = data.meta.current_page
                    this.pagination.rowsPerPage = data.meta.per_page
                    this.pagination.rowsNumber = data.meta.total
                    this.pagination.sortBy = data.meta.sort_by
                    this.pagination.descending = data.meta.descending
                });
            this.loading = false;
        },
        async changeFilter() {
            await this.onRequest({pagination: this.pagination});
        },
        async changePageSize() {
            this.pagination.page = 1;
            await this.changeFilter();
        },
        async clickExport() {
            this.loading = true;
            const {sortBy, descending} = this.pagination
            await this.$http({
                url: `/${this.resource}/export`,
                method: 'POST',
                responseType: 'blob',
                data: {
                    'sortBy': sortBy,
                    'descending': descending,
                    'filters': this.filters.concat(this.additionalFilters),
                }
            })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    let fileName = 'Reporte_' + this.title.replace(/\s+/g, '_') + '_' + moment().format('YYYYMMDDHHmmss')
                    link.setAttribute('download', fileName + '.xlsx');
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(error => {
                    this.errors = error;
                });
            this.loading = false;
        },
        changeDateStart() {
            let period = _.find(this.filters, {'field': 'period'});
            if (period.date_start > period.date_end) {
                period.date_end = period.date_start;
            }
            this.changeFilter();
        },
        changeDateEnd() {
            let period = _.find(this.filters, {'field': 'period'});
            if (period.date_end < period.date_start) {
                period.date_end = period.date_start;
            }
            this.changeFilter();
        },
        changeMonthEnd() {
            let period = _.find(this.filters, {'field': 'period'});
            if (period.month_end < period.month_start) {
                period.month_end = period.month_start;
            }
            this.changeFilter();
        },
        clickCreate(value) {
            this.$emit('click-create', value)
        }
    }
}
</script>
